<!--
- 用户登录（手机端）
- author: lzp
- greatTime: 2019-11-06
- change: wy
- changeTime: 2020-03-08
- changeContent: 添加日包跳转
-->
<template>
<div class="login-container">
  <div class="header">
    <img :src="$store.state.static_img_url+'pic/logo.png'">
  </div>
  <div class="model_content">
    <transition name="fade" mode="out-in">
      <div key="code_logoin" v-if="form_type == 'code_logoin_form'">
        <Form ref="code_logoin_form" :model="code_logoin_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="code_logoin_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            <i class="iconfont">&#xe62f;</i>
          </FormItem>
          <FormItem prop="pic_code">
            <Input v-model="code_logoin_form.pic_code" placeholder="图片验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <img :src="pic_code" class="pic-code" @click="changePicCode">
          </FormItem>
          <FormItem prop="code">
            <Input v-model="code_logoin_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <span class="code_btn" @click="haddleCode()" v-if="userWait == 60">获取验证码</span>
            <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
          </FormItem>
        </Form>
      </div>

      <div key="account_logoin" v-if="form_type == 'account_logoin_form'">
        <Form ref="account_logoin_form" :model="account_logoin_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="account_logoin_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e5;</i>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="account_logoin_form.password" placeholder="请输入密码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e3;</i>
            <p @click="changeForm('forget_paw_form')" class="forget-paw" onclick="_czc.push(['_trackEvent', '顶部导航栏', '忘记密码点击'])">忘记密码?</p>
          </FormItem>
        </Form>
      </div>

      <div key="forget_paw" v-if="form_type == 'forget_paw_form'">
        <Form ref="forget_paw_form" :model="forget_paw_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="forget_paw_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e5;</i>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="forget_paw_form.password" placeholder="请设置密码(6-16位)" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e3;</i>
          </FormItem>
          <FormItem prop="pic_code">
            <Input v-model="forget_paw_form.pic_code" placeholder="图片验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <img :src="pic_code" class="pic-code" @click="changePicCode">
          </FormItem>
          <FormItem prop="code">
            <Input v-model="forget_paw_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <span class="code_btn" @click="haddleCode()" v-if="userWait == 60">获取验证码</span>
            <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
          </FormItem>
        </Form>
      </div>

      <div key="reg" v-if="form_type == 'reg_form'">
        <Form ref="reg_form" :model="reg_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="reg_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e5;</i>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="reg_form.password" placeholder="请设置密码(6-16位)" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e3;</i>
          </FormItem>
          <FormItem prop="pic_code">
            <Input v-model="reg_form.pic_code" placeholder="图片验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <img :src="pic_code" class="pic-code" @click="changePicCode">
          </FormItem>
          <FormItem prop="code">
            <Input v-model="reg_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <span class="code_btn" @click="haddleCode()" v-if="userWait == 60">获取验证码</span>
            <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
          </FormItem>
          <FormItem prop="agreement">
            <div class="agreement">
              <input type="checkbox" v-model="agreement">
              <span>我已经认真阅读同意</span>
              <a @click="showAgreement = true">《动脉网用户使用协议》</a>
            </div>
          </FormItem>
        </Form>
      </div>

      <div key="binding" v-if="form_type == 'binding_form'">
        <Form ref="binding_form" :model="binding_form" :rules="ruleValidate">
          <FormItem prop="mobile">
            <Input v-model="binding_form.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e5;</i>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="binding_form.password" placeholder="请设置密码(6-16位)" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e3;</i>
          </FormItem>
          <FormItem prop="pic_code">
            <Input v-model="binding_form.pic_code" placeholder="图片验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <img :src="pic_code" class="pic-code" @click="changePicCode">
          </FormItem>
          <FormItem prop="code">
            <Input v-model="binding_form.code" placeholder="请输入验证码" autocomplete="off"></Input>
            <i class="iconfont">&#xe6e4;</i>
            <span class="code_btn" @click="haddleCode()" v-if="userWait == 60">获取验证码</span>
            <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
          </FormItem>
        </Form>
      </div>
    </transition>
  </div>

  <div key="1" class="footer" v-if="form_type == 'code_logoin_form' || form_type == 'account_logoin_form'">
    <Button @click="loginOnPhone" :loading="login_button_loading">登录</Button>
    <div class="change-login-way">
      <p @click="changeForm('account_logoin_form')" v-show="form_type == 'code_logoin_form'" onclick="_czc.push(['_trackEvent', '顶部导航栏', '登录方式点击（账号）'])">账号密码登录</p>
      <p @click="changeForm('code_logoin_form')" v-show="form_type == 'account_logoin_form'" onclick="_czc.push(['_trackEvent', '顶部导航栏', '登录方式点击（快捷）'])">手机验证码登录</p>
      <p @click="changeForm('reg_form')" onclick="_czc.push(['_trackEvent', '顶部导航栏', '新用户注册点击'])">新用户注册</p>
    </div>
    <div class="other_way_div">
      <p class="other_way">使用社交账号登录</p>
      <span class="wx_btn" @click="wxLogin" onclick="_czc.push(['_trackEvent', '顶部导航栏', '登录方式点击（微信）'])"><i class="iconfont">&#xe641;</i></span>
    </div>
  </div>
  <div key="2" class="footer" v-if="form_type == 'forget_paw_form'">
    <Button @click="regMobile" :loading="reg_forget_button_loading">重置密码</Button>
    <div class="change-login-way">
      <p @click="changeForm('account_logoin_form')">返回登录</p>
    </div>
  </div>
  <div key="3" class="footer" v-if="form_type == 'reg_form'">
    <Button @click="regMobile" :loading="reg_forget_button_loading">注册</Button>
    <div class="change-login-way">
      <p @click="changeForm('account_logoin_form')"><span>已有账号？</span>去登录 ＞</p>
    </div>
    <div class="other_way_div">
      <p class="other_way">使用社交账号登录</p>
      <span class="wx_btn" @click="wxLogin" onclick="_czc.push(['_trackEvent', '顶部导航栏', '登录方式点击（微信）'])"><i class="iconfont">&#xe641;</i></span>
    </div>
  </div>
  <div key="4" class="footer" v-if="form_type == 'binding_form'">
    <Button @click="bindMobile" :loading="binding_button_loading">绑定手机号</Button>
  </div>

  <Modal class="agree-model" v-model="showAgreement" width="500" fullscreen>
    <div slot="header">
      <p>用户协议</p>
    </div>
    <div class="agree_model_content">
      <div class="three-five-padding weui-article__h3">
        <div class="content">
          <div class="title"> 感谢您使用“动脉网”的产品和服务。 我们尊重并保护所有使用动脉网用户的个人隐私权。</div>
          <div class="bold weui-article__h2">第1条 协议内容及生效</div>
          <div>1.1 本用户协议是用户与“动脉网”之间就相关事宜所订立的契约，即包括本用户协议所有正文及“动脉网”已经发布或将来可能发布的各类规则。用户在“动脉网”注册前，必须事先认真阅读本用户协议，特别是本协议中关于限制、减轻或者免除“动脉网”责任的全部协议内容以及含有限制用户权利的协议内容。</div>
          <div>1.2 如果用户同意本用户协议，或者存在包括下载、注册和使用及连接“动脉网”服务的行为，将被视为完全接受并同意遵守本用户协议的所有内容，包括接受“动脉网”对用户协议随时所做的任何修改，本协议即构成对双方有约束力的法律文件。如不同意本用户协议，用户不得使用或应主动停止使用“动脉网”提供的服务。</div>
          <div>1.3 用户应当为具有完全民事行为能力的自然人，或者是具有独立承担法律责任能力的其他合法主体。若用户属于无民事行为能力、限制民事行为能力人的，或是不具有独立承担法律责任能力的其他主体的，您应在监护人监护下或是得到有权主体授权后使用“动脉网”。</div>
          <div class="bold weui-article__h2">第2条 用户信息</div>
          <div>2.1 用户个人信息。用户个人信息包括真实姓名、手机号码、微信号、所属行业、所在公司，现任职位、常驻城市、本人照片、身份证号、微信支付账号、电子邮箱、个人简介等。</div>
          <div>2.2 非用户个人信息。用户在“动脉网”上，包括阅读、评价、操作状态、使用记录、使用习惯等在内的全部记录信息。除本条第1款所列用户个人信息范围外的所有信息，均为非用户个人信息。</div>
          <div>2.3 第三方平台记录信息。用户通过腾讯微信等第三方平台账号注册、登录、使用“动脉网”服务的，将被视为用户完全理解、同意并接受“动脉网”已包括但不限于收集、统计、分析等方式使用其在腾讯微信等第三方平台填写、登记、公布、记录的全部信息。用户一旦使用第三方平台账号注册、登录、使用“动脉网”服务，“动脉网”对该第三方记录信息的任何使用，均被视为已经获得了用户本人的完全同意并接受。</div>
          <div>2.4 用户自行向“动脉网”提供个人信息、教育经历、工作经历、课程主题和介绍以及其他信息，所提供的信息必须在合法基础上保证真实、准确、完整，并保证及时更新以上信息。如因提供的信息存在非法、抄袭、错误等问题，用户需承担因此引发的相应责任以及后果，且“动脉网”保留终止用户使用“动脉网”各项服务的权利。</div>
          <div>2.5 用户应维护个人“动脉网”帐户和密码安全，并对此帐户在“动脉网”的所有行为负完全责任，不得将帐户借给他人使用，否则应承担由此产生的全部责任，并与实际使用人承担连带责任。当遇到账户或者密码未获授权使用，或者发生任何安全问题时，用户有责任及时有效地通知到“动脉网”并向公安机关报案。</div>
          <div>2.6 用户信息使用，用户在使用过程中发现任何不妥或者不满意之处，有权向“动脉网”提出申请，要求进行相关信息删除等处理；“动脉网”不承担主动删除、销毁用户信息的责任。</div>
          <div>2.7 为向用户提供服务，“动脉网”将在合理范围内使用用户个人信息、非用户个人信息以及第三方平台记录信息。用户一旦注册、登录、使用“动脉网”服务，将被视为“动脉网”已包括但不限于收集、统计、分析、商业用途等方式使用用户信息。“动脉网”对用户信息的使用无需其他意思表示，无需向用户支付任何费用。</div>
          <div class="bold weui-article__h2">第3条 服务条款的修改及终止</div>
          <div>3.1 “动脉网”的服务范围非常广泛，因此有时还会适用一些附加条款或产品要求（包括行业要求）。附加条款将会与相关服务一同提供，并且在用户使用这些服务后，成为您与我们所达成的条款的一部分。</div>
          <div>3.2 “动脉网”始终在不断更改和改进服务。一旦条款及服务内容产生变动，将会在重要页面上提示修改内容。如果不同意我们对条款内容所做的修改，用户可以主动、随时停止使用我们的服务，尽管我们对此表示非常遗憾。</div>
          <div>3.3 “动脉网”也可能随时停止向您提供服务，或随时对我们的服务增加或设置新的限制。 </div>
          <div>3.4 “动脉网”认为用户拥有自己数据的所有权并保留对此类数据的访问权限，这一点非常重要。如果我们停止某项服务，在合理可能的情况下，“动脉网”会向用户发出合理的提前通知，并让用户有机会将信息从服务中汇出。</div>
          <div>3.5 如果用户继续使用“动脉网”的服务，则视为接受服务条款的变动。我们保留随时修改或中断服务的权利。我们行使修改或中断服务的权利，不需对用户或第三方负责。</div>
          <div class="bold weui-article__h2">第4条 服务的中断和终止</div>
          <div>4.1 在未向用户收取相关服务费用的情况下，“动脉网”可自行全权决定以任何理由 (包括但不限于“动脉网”认为用户已违反本条款的字面意义和精神等) 终止对用户的服务。同时“动脉网”可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供全部或部分服务。服务终止后，“动脉网”没有义务为用户保留原用户资料或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。</div>
          <div>4.2 如存在下列情况，“动脉网”可以通过注销用户的方式终止服务： 在用户违反本条款相关规定时，“动脉网”有权终止向该用户提供服务。“动脉网”将在中断服务时通知用户。但如该用户在被“动脉网”终止提供服务后，再一次直接或间接或以他人名义注册为“动脉网”用户的，“动脉网”有权再次单方面终止为该用户提供服务； 一旦“动脉网”发现用户注册资料中主要内容是虚假的，“动脉网”有权随时终止为该用户提供服务； 用户出现作弊行为，网站可根据情况作出处理，甚至注销用户；
            其它“动脉网”认为需终止服务的情况。第三方，但基于交易纠纷、技术原因等因素，“动脉网”保有复制、审查服务过程中录音内容的权利。
          </div>
          <div class="bold weui-article__h2">第5条 用户言行</div>
          <div>5.1 用户同意在使用“动脉网”服务过程中，必须严格遵守以下规则： 1) 遵守中国法律法规、行政规章以及规范性文件； 2) 遵守“动脉网”的所有用户协议、通知、协议等文件； 3) 不得为违法、犯罪等目的使用“动脉网”网站及其移动客户端； 4) 不得在“动脉网”上传输及发布以下内容：煽动抗拒、破坏宪法及法律法规实施的言论；煽动颠覆国家政权、破坏国家统一的言论；违背社会风俗和社会道德的言论；煽动民族仇恨、民族歧视，破坏民族团结的言论； 5)
            不得使用任何侮辱或毁谤他人，性骚扰，或对未成年人有不良影响的内容；
            6) 不得散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为； 7) 不得利用本站从事洗钱、窃取商业秘密、窃取其他用户个人信息等违法犯罪活动； 8) 不得侵入本站及国家计算机信息系统，不得传播病毒、特洛伊木马、定时炸弹等可能对“动脉网”造成伤害或影响其正常运转的恶意病毒或程序； 9) 不得在“动脉网”平台从事非经“动脉网”同意的所有牟利性经营活动； 10) 不得侵犯第三方权利，特别是他人著作权、商标权等知识产权或者合法权利。</div>
          <div>5.2 若用户有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，“动脉网”保有删除各类不符合法律政策或者不真实信息内容而无须通知用户的权利。若用户未遵守以上约定，“动脉网”有权立即终止对用户提供服务，采取暂停或者关闭用户账户等措施。用户须对自己的言论和行为负法律责任。</div>
          <div class="bold weui-article__h2">第6条 知识产权协议</div>
          <div>6.1 对于用户通过“动脉网”发布的任何公开信息，用户同意“动脉网”在全世界范围内具有将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中的权利。</div>
          <div>6.2 除法律规定外，未经“动脉网”书面等任何形式明确许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用“动脉网”的信息内容，否则，“动脉网”有权追究其法律责任。</div>
          <div>6.3 用户在“动脉网”所发布的内容，必须保证已经拥有必要权利或授权以进行该内容的提供、发布、提交等行为。</div>
          <div>6.4 本用户协议已经构成《中华人民共和国著作权法》及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在“动脉网”上发布的任何受著作权法保护的作品内容。</div>
          <div class="bold weui-article__h2">第7条 隐私声明</div>
          <div>“动脉网”非常重视对用户个人隐私的保护。 “动脉网”在必要时候需要某些信息才能为您提供所请求的服务，本隐私声明针对这些情况下的数据收集和使用情况。作为“动脉网”用户，如果同意接受“动脉网”用户协议及隐私声明，表明您授权“动脉网”对任何您所提供的、或者“动脉网”所收集到的信息有权进行处理、传播、使用。
            本隐私声明适用于“动脉网”的所有服务，随着服务的变化，“动脉网”有权对隐私条款不时进行修改更新，且不再另行通知。更新后的隐私声明一旦公布即有效代替原来的隐私声明，您在访问和使用“动脉网”时，即表示您已同意遵守并接受最新的隐私政策。建议您及时关注隐私条款的变更。
          </div>
          <div>7.1 “动脉网”隐私信息范围，通常情况下，在“动脉网”注册、获取服务时所提交的个人信息，包括姓名、联系方式、通讯地址、第三方帐户信息等。</div>
          <div>7.2 信息隐私的保护</div>
          <div>“动脉网”严格保护您个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄露。 当用户对网站或者移动客户端的服务表示兴趣时，或者向用户提供服务出现问题或者困难时，我们使用这些信息来联系用户。 未经用户同意，“动脉网”不会向第三方提供用户信息，也不会在用户之间传递这些信息。未经用户同意，“动脉网”不会对用户之间的交流信息，包括评价、交流文本和图片内容进行编辑、筛选、篡改。
          </div>
          <div>如果有明确证据表明您所提供的信息存在不符合法律政策或者不真实情况，我们有权无须通知您对信息进行删除、更改等处理。</div>
          <div class="bold weui-article__h2">第8条 免责说明</div>
          <div>8.1 就下列相关事宜的发生，“动脉网”不承担任何法律责任： 1）用户应遵守国家的有关法律、法规和行政规章制度。如有用户违反国家法律法规或本用户协议，“动脉网”有权停止向用户提供任务而不需要承担任何责任，如导致“动脉网”遭受任何损害或者遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向“动脉网”赔偿相应的损失，用户需对其违反用户协议所产生的一切后果承担全部法律责任。
            2）由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄露，或其他非因“动脉网”原因导致的个人信息的泄露；
            3）根据法律规定或政府相关政策要求提供您的个人信息； 4）任何通过黑客攻击、电脑病毒侵入等非法截取、访问等方式从我们网站上获取的信息； 5）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素导致的任何后果；
          </div>
          <div>8.2 本服务涉及到互联网及移动通讯等服务，可能受各个环节不稳定因素的影响，比如不可抗力、计算机病毒或者黑客攻击等造成的服务中断或不能满足用户要求的风险，用户须理解和认可，并承担以上风险。“动脉网”对服务的及时性、安全性、准确性不作担保，对因此导致用户不能接收信息，或者传递错误等问题不承担任何责任。</div>
          <div>8.3 如“动脉网”的系统发生故障影响到本服务的正常运行，“动脉网”承诺第一时间内与相关单位配合，及时处理进行修复。但用户因此而产生的经济损失，“动脉网”不承担责任。此外，“动脉网”保留未经事先通知为维修保养、升级或其他目的暂停本服务任何部分的权利。</div>
          <div class="bold weui-article__h2">第9条 适用法律框架以及纠纷解决途径</div>
          <div>9.1 本协议的订立、执行和解释及争议的解决均应适应中国法律。</div>
          <div>9.2 如双方就本协议内容或其执行发生争议，双方应尽量友好协商解决；协商不成时应任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</div>
          <div class="bold weui-article__h2">第10条 其他</div>
          <div>10.1 如果您在中国大陆以外的国家或地区访问或使用“动脉网”，您有责任遵守所在辖区内有关在线行为和可接受内容的法律。</div>
          <div>10.2 本服务的所有权、运作权和一切解释权归“动脉网”所有。“动脉网”有权在必要时修改用户协议，并通过网站或者客户端发布修改变更，且不再另行通知。如果在更改生效后用户继续使用服务，则视为您接受用户协议的变动并遵守最新用户协议。</div>
          <div>如果您对用户协议有任何疑问，请联系客服(微信同号)：13627682184</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="agreement-footer">
      <Button type="primary" @click="showAgreement=false">我看完了</Button>
    </div>
  </Modal>
</div>
</template>
<script>
import {
  loginOnPhone,
  sendCode,
  loginOnWx,
  regMobile,
  checkMobileReg,
  bindMobile,
  imgcode,
  createThemeTypeOrder,
  getUserPayThemeType
} from '../service'
import {
  user_mixin
} from 'mobile/js/user_mixin'
import moment from 'moment'
export default {
  name: 'Login',
  // props: ['loginModal'],
  mixins: [user_mixin],
  data() {
    return {
      // loginIndex: false,
      // loginWxIndex: false,
      first_login: true,
      form_type: 'account_logoin_form',
      code_logoin_form: {
        mobile: '',
        code: '',
        pic_code: "",
        login_type: '1'
      },
      account_logoin_form: {
        mobile: '',
        password: '',
        login_type: '2'
      },
      forget_paw_form: {
        mobile: "",
        password: "",
        code: "",
        pic_code: "",
        type: "2",
      },
      reg_form: {
        mobile: "",
        password: "",
        code: "",
        pic_code: "",
        type: "1",
      },
      agreement: true,
      showAgreement: false,
      binding_form: {
        mobile: "",
        password: "",
        code: "",
        pic_code: "",
        user_key: "",
      },

      ruleValidate: {
        'mobile': [{
            required: true,
            message: '请输入您的联系电话',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[34578]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }
          }
        ],
        'code': [{
          required: true,
          message: '请填写正确的验证码',
          trigger: 'blur'
        }],
        'pic_code': [{
          required: true,
          message: '请填写正确的图片验证码',
          trigger: 'blur'
        }],
        'password': [{
            required: true,
            message: '请填写正确的密码',
            trigger: 'blur'
          },
          {
            min: 6,
            message: '密码长度至少需要6个字符',
            trigger: 'blur'
          },
          {
            max: 16,
            message: '密码长度不能超过16个字符',
            trigger: 'blur'
          }
        ]
      },
      userWait: 60,
      codeTimeout: '',
      login_button_loading: false,
      reg_forget_button_loading: false,
      binding_button_loading: false,
      pic_code: ''
    }
  },
  computed: {
    code() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      var value = theRequest['code']
      return value
    },
    state() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      var value = theRequest['state']
      return value
    },
    path_link() {
      let host = ''
      if (process.env.NODE_ENV == 'development') {
        host = 'http://192.168.1.104:8010'
      } else {
        host = 'https://api.vcbeat.top'
      }
      return host
    },
    random() {
      return Math.random()
    }
  },
  methods: {
    haddleCode() { // 验证手机号是否填写吧
      this.$refs[this.form_type].validateField('mobile', async (valid) => {
        this.$refs[this.form_type].validateField('pic_code', async (valid2) => {
          if (!valid && !valid2) {
            if (this.form_type == 'reg_form' || this.form_type == 'binding_form') { // 注册和绑定验证手机唯一性
              let check_back = await checkMobileReg(this[this.form_type], (error) => {
                this.$Message.error('请求失败！')
              })
              if (check_back.status == 'success') {

              } else {
                this.$Message.error(check_back.message)
                return
              }
            }

            let res = await sendCode({
              mobile: this[this.form_type].mobile,
              code: this[this.form_type].pic_code
            }, (error) => {
              this.$Message.error('请求失败！')
            })
            if (res.status == 'success') {
              this.userCodeClk()
            }
            if (res.status == 'error') {

              if (res.code == 4) {
                this.$Message.error('图片验证码错误')
              } else {
                this.$Message.error(res.message)
              }
            }
          }
        })
      })
    },
    loginOnPhone() { // 验证码登录和账号密码
      this.$refs[this.form_type].validate(async (valid) => {
        if (valid) {
          this.login_button_loading = true
          if (this.form_type == 'account_logoin_form') {
            this[this.form_type].code = this[this.form_type].password
          }
          let res = await loginOnPhone(this[this.form_type], (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            localStorage.user_key = res.user_key
            localStorage.user = JSON.stringify(res.user)
            localStorage.timestamp_left = moment().unix()
            localStorage.timestamp_right = moment().unix()
            this.$store.commit('updateUserKey', res.user_key)
            this.$store.commit('updateUser', res.user)
            // this.loginIndex = false
            // this.getSubscribeList()
            this.cb()
          } else {
            // type 2 信息不完全
            if (res.type == 3) { // 用户未注册
              this.changeForm('reg_form')
            }
            this.$Message.error(res.message)
          }
          this.login_button_loading = false
        }
      })
    },
    regMobile() { // 注册和忘记密码
      if (this.form_type == 'reg_form' && !this.agreement) {
        this.$Message.warning('请先认真阅读同意《动脉网用户使用协议》')
        return
      }
      this.$refs[this.form_type].validate(async (valid) => {
        if (valid) {
          this.reg_forget_button_loading = true
          let res = await regMobile(this[this.form_type], (error) => {
            this.$Message.error('请求错误！')
          })
          if (res.status == 'success') {
            this.$Message.success(this.form_type == 'reg_form' ? '注册成功，请登录！' : '重置密码成功，请登录！')
            this.$refs[this.form_type].resetFields()
            this.form_type = 'account_logoin_form'
          } else {
            this.$Message.error(res.message)
          }
          this.reg_forget_button_loading = false
        }
      })
    },
    bindMobile() { // 微信用户绑定手机号
      this.$refs[this.form_type].validate(async (valid) => {
        if (valid) {
          this.binding_button_loading = true
          this[this.form_type].user_key = this.$store.state.before_user_key
          let res = await bindMobile(this[this.form_type], (error) => {
            this.$Message.error('请求错误！')
          })
          if (res.status == 'success') {
            localStorage.user = JSON.stringify(res.user)
            localStorage.timestamp_left = moment().unix()
            localStorage.timestamp_right = moment().unix()
            this.$store.commit('updateUserKey', res.user_key)
            this.$store.commit('updateUser', res.user)
            // this.loginIndex = false
            // this.getSubscribeList()
            this.cb()
          } else {
            this.$Message.error(res.message)
          }
          this.binding_button_loading = false
        }
      })
    },
    userCodeClk() { // 获取验证码倒数
      if (this.userWait == 0) {
        this.userWait = 60;
      } else {
        this.userWait--;
        this.codeTimeout = setTimeout(() => {
          this.userCodeClk()
        }, 1000)
      }
    },
    // loginModalCancel() { //  取消模态框，更新状态
    //   this.agreement = true
    //   this.changeForm('account_logoin_form')
    //   this.$emit('logincancel', this.loginIndex)
    // },
    wxLogin() { // 微信登录
      // const link = location.href
      // var url = escape(link)
      // var obj = new WxLogin({
      //     id: "wx_login",
      //     appid: "wx6f7be6ecbba6000b",
      //     scope: "snsapi_login",
      //     redirect_uri: url,
      //     state: "wxlogin",
      //     style: "black",
      //     href: ""
      // });
      // this.loginIndex = false
      // this.loginWxIndex = true
      location.replace('https://pay.vcbeat.top/wx/code?redirect_uri=' + escape(location.href) + '&scope=snsapi_userinfo')
    },
    async getWxLogin() {
      let res = await loginOnWx({
        code: this.code,
        is_mobile: 1
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        localStorage.user_key = res.user_key
        localStorage.user = JSON.stringify(res.user)
        localStorage.timestamp_left = moment().unix()
        localStorage.timestamp_right = moment().unix()
        this.$store.commit('updateUserKey', res.user_key)
        this.$store.commit('updateUser', res.user)
        // this.loginIndex = false
        // this.getSubscribeList()
        this.cb()
      } else {
        if (res.type == 2) {
          this.$store.commit('beforeUserKey', res.user_key)
          this.changeForm('binding_form')
          // this.loginWxIndex = false
          // this.loginIndex = true
        }
        this.$Message.warning(res.message)
      }
    },
    changeForm(form_name) { // 切换表单
      this.userWait = 60
      clearTimeout(this.codeTimeout)
      if (form_name != 'binding_form') {
        this.$refs[this.form_type].resetFields()
      } else {
        this.binding_form = {
          mobile: "",
          password: "",
          code: "",
          user_key: ""
        }
      }
      let temp_obj = {
        'code_logoin_form': '验证码登录',
        'account_logoin_form': '登录',
        'forget_paw_form': '忘记密码',
        'reg_form': '用户注册',
        'binding_form': '绑定手机号'
      }
      this.$store.commit('updateHtmlTitle', temp_obj[form_name])
      this.form_type = form_name
    },
    changePicCode(t) {
      this.pic_code = this.path_link + '/dg/imgcode?' + Math.random()
    },
    async cb() { // 登录成功后的回调
      const order_actions = {
        'theme_type_id': createThemeTypeOrder
      }
      if ('action' in this.$route.query) {
        switch (this.$route.query.action) {
          case 'buy':
            if ('theme_type_id' in this.$route.query) {
              let pay_theme_id_res = await getUserPayThemeType({
                user_key: this.$store.state.user_key
              })
              if (pay_theme_id_res.status == 'success') {
                if (pay_theme_id_res.res.find(item => item.theme_type_id == this.$route.query.theme_type_id) || this.is_vip) {
                  this.goBack()
                } else {
                  if (!this.user.name || !this.user.compName || !this.user.title) {
                    this.$router.replace({
                      name: 'MCollectInfo',
                      query: {
                        'theme_type_id': this.$route.query.theme_type_id,
                        type: this.$route.query.type,
                        url: this.$route.query.url
                      }
                    })
                  } else {
                    let res = await order_actions['theme_type_id']({
                      user_key: this.$store.state.user_key,
                      theme_type_id: this.$route.query.theme_type_id
                    })
                    if (res.status == 'success') {
                      this.$router.replace({
                        name: 'MBuyInfo',
                        params: {
                          order_uid: res.order_uid,
                          type: this.$route.query.type
                        },
                        query: {
                          url: this.$route.query.url
                        }
                      })
                    } else {
                      this.$Message.error(res.message)
                    }
                  }
                }
              } else {
                this.$Message.error(res.message)
              }
            }
            break;
          default:
            this.goBack()
        }
      } else {
        this.goBack()
      }
    },
    goBack() { // 返回上一页
      // if (this.$route.query.test == true) {
      //   this.$router.replace({ name: 'MApplyTest'})
      // } else {
        
      // }
      if (navigator.userAgent.indexOf('iPhone') > 0) {
          // this.$router.replace({path: Buffer(this.$route.query.url, 'base64').toString()})
          this.$router.replace({
            path: unescape(this.$route.query.url)
          })
        } else {
          this.$router.go(-1)
        }
    }
  },
  created() {
    this.$store.commit('updateHtmlTitle', '登录')
    if (this.code && !localStorage.user_key) {
      this.getWxLogin()
    }
    this.pic_code = this.path_link + '/dg/imgcode'
  },
  mounted() {
    jQuery(
      $("input").focus(function() {
        $('.other_way_div').addClass('other_way_div_relative')
      })
    )
    jQuery(
      $("input").blur(function() {
        $('.other_way_div').removeClass('other_way_div_relative')
      })
    )
    let ori_height = window.innerHeight
    window.onresize = function() {
      if (window.innerHeight == ori_height) {
        jQuery(
          $('.other_way_div').removeClass('other_way_div_relative')
        )
      } else {
        jQuery(
          $('.other_way_div').addClass('other_way_div_relative')
        )
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
transition_02s()
  transition: all .2s
translateY50()
  transform: translate(0, -50%)
.login-container
  .header
    text-align: center;
    margin-top: .6rem;
    margin-bottom: .7rem;
    img
      height: .8rem;
      -webkit-box-reflect: below 0px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(60%, transparent), to(rgba(250, 250, 250, 0.1)));
  .model_content
    padding: 0 .8rem;
    >>>.ivu-form-item
      margin-bottom: .6rem;
      .ivu-form-item-content
        position: relative;
        >i
          position: absolute;
          top: 0;
          left: 0;
          color: #CCCCCC;
        .forget-paw,.code_btn,>img
          position: absolute;
          top: 0;
          right: 0;
          color: rgba(250, 122, 80, 1);
        .disabled_btn
          color: #999999;
        .ivu-form-item-error-tip
          padding-top: .16rem
      input
        border: 0;
        border-bottom: 1px solid #DDDDDD;
        border-radius: 0;
        padding: .2rem .2rem .2rem .5rem;
        color: #333333;
        font-size: .28rem;
        &:focus
          border-color: rgba(250, 122, 80, 1);
          box-shadow: none;
      &.ivu-form-item-error
        input
          border-color: #F3494B
      .agreement
        line-height: 0;
        input
          margin-right: .1rem;
        span
          color: #999999;
          vertical-align: middle;
        a
          color: rgba(250, 122, 80, 1);
          vertical-align: middle;
  .footer
    margin-top: .8rem;
    padding: 0 .8rem;
    button
      width: 100%;
      background:linear-gradient(131deg,#FA5A00 0%,#fa7a50 100%);
      box-shadow:0px 5px 15px 0px rgba(121,133,143,0.4);
      border-radius: .1rem;
      height: .88rem;
      color: #FFFFFF;
      font-weight: bold;
      font-size: .32rem;
    .change-login-way
      display: flex;
      justify-content: center;
      margin-top: .56rem;
      padding-bottom: 2rem;
      background: #ffffff;
      z-index: 1000;
      p
        font-size: .24rem;
        color: rgba(250, 122, 80, 1);
      p:nth-child(3)
        &:before
          content: '|';
          margin: 0 .3rem;
          color:#CCCCCC;
    .other_way_div_relative
      position: relative !important;
    .other_way_div
      width: 100%;
      position: fixed;
      left: 0;
      bottom: .4rem;
      padding: 0 .8rem;
      z-index: 100;
      .other_way
        text-align: center
        line-height: 1
        font-size: .24rem;
        color: #999
        &:after
        &:before
          position: absolute
          content: ''
          width: 80px
          top: .12rem
          translateY50()
          border-top: 1px solid #E9E9E9
          right: .8rem
        &:after
          left: .8rem
      .wx_btn
        display: block
        border:1px solid #67CD64;
        font-size: 0
        text-align: center
        width: .8rem
        height: .8rem
        line-height: .8rem
        border-radius: 50%
        margin: 10px auto 0
        cursor: pointer
        transition_02s()
        .iconfont
          font-size: .34rem;
          color: #67CD64
.agree-model
  >>>.ivu-modal-wrap
    .ivu-modal-header
      p
        text-align: center;
    .ivu-modal-body
      padding: .2rem;
      .content
        border: 1px dashed #FC9C7C;
        border-radius: .2rem;
        padding: .32rem;
        >div
          font-size: .28rem;
          line-height: .44rem;
          color: #333333;
        .weui-article__h2
          font-weight: bold;
          padding-bottom: .16rem;
          border-bottom: 1px solid #FC9C7C
          margin: .4rem 0
</style>
